import Vue from 'vue'
import Router from 'vue-router'

const DefaultContainer = () => import(/* webpackChunkName: "default" */'../layout/DefaultLayout')

const Login = () => import(/* webpackChunkName: "default" */'../views/Auth/Login')
const ForgotPassword = () => import(/* webpackChunkName: "default" */'../views/Auth/ForgotPassword')
const ResetPassword = () => import(/* webpackChunkName: "default" */'../views/Auth/ResetPassword')
const Erro404 = () => import(/* webpackChunkName: "default" */'../views/Errors/404')
const TermsAndConditions = () => import(/* webpackChunkName: "default" */'../views/TermsAndConditions')

const Dashboard = () => import(/* webpackChunkName: "default" */'../views/Home')
const Users = () => import(/* webpackChunkName: "users" */'../views/Users/Users')
const UsersEdit = () => import(/* webpackChunkName: "users" */'../views/Users/Edit')
const UserCourseResults = () => import(/* webpackChunkName: "users" */'../views/Users/CourseResults')
const UserProgression = () => import(/* webpackChunkName: "users" */'../views/Users/Progressions')
const UserTrainingPlan = () => import(/* webpackChunkName: "users" */'../views/Users/TrainingPlan')

const Messages = () => import(/* webpackChunkName: "messages" */'../views/Messages/Index')
const Thread = () => import(/* webpackChunkName: "messages" */'../views/Messages/Message')

const Training = () => import(/* webpackChunkName: "training" */'../views/Training/Training')
const Assignment = () => import(/* webpackChunkName: "training" */'../views/Forms/Assignment')
const TrainingUnits = () => import(/* webpackChunkName: "training" */'../views/Training/TrainingUnits')
const TrainingModules = () => import(/* webpackChunkName: "training" */'../views/Training/TrainingModules')

const Forms = () => import(/* webpackChunkName: "forms" */'../views/Forms/Forms')
const Submissions = () => import(/* webpackChunkName: "forms" */'../views/Submissions/Submissions')
const EditForm = () => import(/* webpackChunkName: "forms" */'../views/Forms/EditForm')
const Worklogs = () => import(/* webpackChunkName: "forms" */'../views/Forms/Worklogs')

const Notifications = () => import(/* webpackChunkName: "notifications" */'../views/Notifications')
const EvidenceGalleryIndex = () => import(/* webpackChunkName: "evidence" */'../views/EvidenceGallery/Index')
const EvidenceGallery = () => import(/* webpackChunkName: "evidence" */'../views/EvidenceGallery/Gallery')
const SingleSubmission = () => import(/* webpackChunkName: "forms" */'../views/Submissions/SingleSubmission')

const UserActivity = () => import(/* webpackChunkName: "Reports" */'../views/Reports/UserActivity')
const UserReports = () => import(/* webpackChunkName: "Reports" */'../views/Reports/UserReports')
const SignoffFormsReport = () => import(/* webpackChunkName: "Reports" */'../views/Reports/SignoffForms')

const SignoffFormsList = () => import(/* webpackChunkName: "signoff_forms" */'../views/SignoffForms/SignoffFormsList')
const SignoffFormFill = () => import(/* webpackChunkName: "signoff_forms" */'../views/SignoffForms/SignoffFormsFill')

const FileBrowser = () => import(/* webpackChunkName: "tools" */'../views/Tools/FileBrowser')
const Analytics = () => import(/* webpackChunkName: "tools" */'../views/Tools/Analytics')

const VideoLibrary = () => import(/* webpackChunkName: "videos" */'../views/VideoLibrary')
const UploadVideoLibrary = () => import(/* webpackChunkName: "videos" */'../views/Tools/UploadVideoLibrary')
const EditVideoLibrary = () => import(/* webpackChunkName: "videos" */'../views/Tools/EditVideoLibrary')
const RolesList = () => import(/* webpackChunkName: "roles" */'../views/Tools/Roles/Roles')
const RtosList = () => import(/* webpackChunkName: "rtos" */'../views/Tools/Rtos/Rtos')
const RolesEdit = () => import(/* webpackChunkName: "roles" */'../views/Tools/Roles/Edit')
const RtosEdit = () => import(/* webpackChunkName: "rtos" */'../views/Tools/Rtos/Edit')

const UnitsManager = () => import(/* webpackChunkName: "streams_manager" */'../views/UnitsManager/Units')
const StreamManager = () => import(/* webpackChunkName: "streams_manager" */'../views/UnitsManager/StreamManager')
const EditUnit = () => import(/* webpackChunkName: "streams_manager" */'../views/UnitsManager/EditUnit')
const EditStream = () => import(/* webpackChunkName: "streams_manager" */'../views/UnitsManager/EditStream')
const EditSection = () => import(/* webpackChunkName: "streams_manager" */'../views/UnitsManager/EditSection')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      meta: {
        auth: true
      },
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          meta: {
            auth: true
          },
          component: Dashboard
        },
        {
          path: 'signoff_forms',
          name: 'SignoffFormsList',
          meta: {
            auth: true
          },
          component: SignoffFormsList
        },
        {
          path: 'signoff_forms/:id',
          name: 'SignoffFormFill',
          meta: {
            auth: true
          },
          component: SignoffFormFill,
          props: true
        },
        {
          path: 'videos',
          name: 'VideoLibrary',
          meta: {
            auth: true
          },
          component: VideoLibrary
        },
        {
          path: 'videos/upload',
          name: 'UploadVideoLibrary',
          meta: {
            auth: ['admin', 'super_admin']
          },
          component: UploadVideoLibrary
        },
        {
          path: 'videos/:id/edit',
          name: 'EditVideoLibrary',
          meta: {
            auth: ['admin', 'super_admin']
          },
          component: EditVideoLibrary,
          props: true
        },

        {
          path: 'evidence_gallery',
          name: 'EvidenceGalleryIndex',
          meta: {
            auth: true
          },
          component: EvidenceGalleryIndex
        },
        {
          path: 'evidence_gallery/:id',
          name: 'EvidenceGallery',
          meta: {
            auth: true
          },
          component: EvidenceGallery,
          props: true
        },

        {
          path: 'users',
          name: 'Users',
          meta: {
            auth: ['admin', 'super_admin', 'rto', 'rto_trainer', 'employer', 'workplace_supervisor']
          },
          component: Users
        },
        {
          path: 'users/:id/results',
          name: 'UserCourseResults',
          meta: {
            auth: true
          },
          component: UserCourseResults,
          props: true
        },
        {
          path: 'users/:id/training_plan',
          name: 'UserTrainingPlan',
          meta: {
            auth: ['admin', 'super_admin', 'rto', 'rto_trainer']
          },
          component: UserTrainingPlan,
          props: true
        },
        {
          path: 'users/:id/progression',
          name: 'UserProgression',
          meta: {
            auth: true
          },
          component: UserProgression,
          props: true
        },
        {
          path: 'users/create',
          name: 'UsersCreate',
          meta: {
            auth: ['admin', 'super_admin', 'rto', 'rto_trainer']
          },
          component: UsersEdit,
          props: true
        },
        {
          path: 'users/:id',
          name: 'UsersEdit',
          meta: {
            auth: true
          },
          component: UsersEdit,
          props: true
        },
        {
          path: '/messages',
          name: 'Messages',
          meta: {
            auth: true
          },
          component: Messages
        },
        {
          path: '/messages/:id',
          name: 'Thread',
          meta: {
            auth: true
          },
          component: Thread,
          props: true
        },
        {
          path: '/notifications',
          name: 'Notifications',
          meta: {
            auth: true
          },
          component: Notifications
        },
        {
          path: '/submissions/:id',
          name: 'SingleSubmission',
          meta: {
            auth: true
          },
          component: SingleSubmission,
          props: true
        },
        {
          path: '/training_plan/',
          name: 'TrainingUnits',
          meta: {
            auth: true
          },
          component: TrainingUnits,
          props: true
        },
        {
          path: '/training_plan/:id',
          name: 'TrainingModules',
          meta: {
            auth: true
          },
          component: TrainingModules,
          props: true
        },
        {
          path: '/training/:id',
          name: 'Training',
          meta: {
            auth: true
          },
          component: Training,
          props: true
        },
        {
          path: '/assignment/:id',
          name: 'Assignment',
          meta: {
            auth: true
          },
          component: Assignment,
          props: true
        },
        {
          path: '/reports/user_activity',
          name: 'UserActivity',
          meta: {
            auth: ['admin', 'super_admin', 'rto', 'rto_trainer']
          },
          component: UserActivity
        },
        {
          path: '/reports/user_reports',
          name: 'UserReports',
          meta: {
            auth: ['admin', 'super_admin', 'rto', 'rto_trainer']
          },
          component: UserReports
        },
        {
          path: '/reports/signoff_forms',
          name: 'SignoffFormsReport',
          meta: {
            auth: ['admin', 'super_admin', 'rto', 'rto_trainer']
          },
          component: SignoffFormsReport
        },
        {
          path: '/tools/filebrowser/:id?',
          name: 'FileBrowser',
          meta: {
            auth: ['admin', 'super_admin', 'rto', 'rto_trainer']
          },
          component: FileBrowser,
          props: true
        },
        {
          path: '/tools/analytics',
          name: 'Analytics',
          meta: {
            auth: ['admin', 'super_admin']
          },
          component: Analytics
        },
        {
          path: '/tools/roles',
          name: 'RolesList',
          meta: {
            auth: ['admin', 'super_admin']
          },
          component: RolesList
        },
        {
          path: '/tools/rtos',
          name: 'RtosList',
          meta: {
            auth: ['admin', 'super_admin']
          },
          component: RtosList
        },
        {
          path: '/tools/roles/:id',
          name: 'RolesEdit',
          meta: {
            auth: ['admin', 'super_admin']
          },
          component: RolesEdit,
          props: true
        },
        {
          path: '/tools/rtos/:id',
          name: 'RtosEdit',
          meta: {
            auth: ['admin', 'super_admin']
          },
          component: RtosEdit,
          props: true
        },
        {
          path: 'units',
          name: 'Units',
          meta: {
            auth: ['admin', 'super_admin', 'content_curator']
          },
          component: UnitsManager
        },
        {
          path: 'streams',
          name: 'Streams',
          meta: {
            auth: ['admin', 'super_admin', 'content_curator']
          },
          component: StreamManager
        },
        {
          path: 'units/:id',
          name: 'EditUnit',
          meta: {
            auth: ['admin', 'super_admin', 'content_curator']
          },
          component: EditUnit,
          props: true
        },
        {
          path: 'streams/:id',
          name: 'EditStream',
          meta: {
            auth: ['admin', 'super_admin', 'content_curator']
          },
          component: EditStream,
          props: true
        },
        {
          path: 'units/section/:id',
          name: 'EditSection',
          meta: {
            auth: ['admin', 'super_admin', 'content_curator']
          },
          component: EditSection,
          props: true
        },
        {
          path: 'forms',
          name: 'Forms',
          meta: {
            auth: ['admin', 'super_admin', 'content_curator']
          },
          component: Forms
        },
        {
          path: 'submissions',
          name: 'Submissions',
          meta: {
            auth: true
          },
          component: Submissions
        },
        {
          path: 'forms/:id',
          name: 'EditForm',
          meta: {
            auth: ['admin', 'super_admin', 'content_curator']
          },
          component: EditForm,
          props: true
        },
        {
          path: 'worklogs/:id',
          name: 'Worklogs',
          meta: {
            auth: 'employer'
          },
          component: Worklogs,
          props: true
        }
      ]
    },
    {
      path: '/login/forgot',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        auth: false
      }
    },
    {
      path: '/reset/:token',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        auth: false
      },
      props: true
    },
    {
      path: '/login/:provider?',
      name: 'Login',
      component: Login,
      meta: {
        auth: false
      },
      props: true
    },
    {
      path: '/terms-and-conditions',
      name: 'TermsAndConditions',
      component: TermsAndConditions
    },
    {
      path: '*',
      name: 'Erro404',
      component: Erro404
    }
  ]
})
